import React, { SVGProps } from 'react';

import { IEventsCategoryEnum } from '@r-client/data/graphql-types';
import {
  Cocktail,
  Coffee,
  Cutlery,
  Dinner,
  Globe,
  Microphone,
  Play,
  SvgIconLight,
} from '@r-client/shared/ui/icons';

interface IEventCategoryIconProps {
  category: IEventsCategoryEnum;
  className?: string;
  iconClassName?: string;
}

const EventCategoryMap = {
  [IEventsCategoryEnum.Breakfast]: Coffee,
  [IEventsCategoryEnum.Cocktails]: Cocktail,
  [IEventsCategoryEnum.Dinner]: Dinner,
  [IEventsCategoryEnum.FacebookLive]: Play,
  [IEventsCategoryEnum.Lunch]: Cutlery,
  [IEventsCategoryEnum.Webcast]: Microphone,
  [IEventsCategoryEnum.Showcase]: Globe,
};

const getIconByCategory = (
  category: IEventsCategoryEnum
): React.FC<SVGProps<SVGSVGElement>> | undefined => {
  return EventCategoryMap[category];
};

export const EventCategoryIcon: React.FC<
  React.PropsWithChildren<IEventCategoryIconProps>
> = ({ category, className, iconClassName }) => {
  const Component = getIconByCategory(category);
  return Component ? (
    <SvgIconLight
      className={className}
      iconClassName={iconClassName}
      icon={Component}
    />
  ) : null;
};
